import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { PricingModelGrid, PricingModelGridPluginSettings } from ".";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";

const PricingModelSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const gridId = uuidv4();
    const plugin = PricingModelGridPluginSettings
    const { t } = useTranslation();
    return (
        <GridSelectorModalWindow gridDisplayName={t('directory.pricingModel.title')}
            entityToPressEnter={entity}
            fullScreen
            modalKey="pricingModelSelectorModal"
            ok={{ onClick: () => props.ok?.(entity) }}
            cancel={{ onClick: () => props.cancel?.() }}>
            {
                plugin
                    ? <PricingModelGrid gridId={gridId} plugin={plugin} baseGridFilter={props.gridFilter}
                        onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.(entity)
                        }}
                    />
                    : <p>{t('general.directoryNotConfigured')}</p>
            }
        </GridSelectorModalWindow>
    )
}

export default PricingModelSelectorModal